import Vue from 'vue'
import dayjs from 'dayjs'
import { VitalsignSettingFetcher as VitalsignSettingFetcherType } from '@/ble/vitalsignSettingFetcher/types'
import { VitalsignSetting } from '@/types/vitalsign'

const DEFAULT_PATIENCE_TERM_SEC = 60

const VitalsignSettingFetcher: VitalsignSettingFetcherType = {
  lastFetchedTimestamp: null,
  lastFetchedSettings: null,

  async getSettings(
    patientId: number,
    patienceTerm = DEFAULT_PATIENCE_TERM_SEC
  ) {
    if (this.lastFetchedTimestamp === null) {
      await this.refreshSetting(patientId)
    } else if (this.lastFetchedTimestamp < dayjs().unix() - patienceTerm) {
      await this.refreshSetting(patientId)
    }

    return this.lastFetchedSettings as VitalsignSetting
  },

  async refreshSetting(patientId: number) {
    const setting = await Vue.$api.vitalsign.fetchSetting({
      patientId
    })

    this.lastFetchedTimestamp = dayjs().unix()
    this.lastFetchedSettings = setting
  }
}

export default VitalsignSettingFetcher
